import Storage from "@/utils/Storage";
import http from "@/utils/http";

class Token extends Storage{
    getToken(key){
        var result = super.get(key);

        //token剩余时间
        var detail = -1;
        if(result){
            detail = result['max_age'] * 1000 - new Date();
        }

        //检测是否已经过期
        if(!result || Object.keys(result) == 0 || detail < 0){
            return false;
        }

        //剩余5分钟则刷新token
        // if(detail < 5 * 60 * 1000){
        //     this.refreshToken(key);
        // }
        return result['token'];
    }
    setToken(key, value){
        super.set(key, value, value['expiry']);
    }
    refreshToken(key){
        http.get("/api/v1/token/refresh/" + key).then(res =>{
            this.setToken(res.data);
        });

        return true;
    }
}

export default Token;


// WEBPACK FOOTER //
// ./src/common/Token.js